<template>
    <div style="display:flex;justify-content: center; align-items: center; height: 91vh;">
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin"></div>
        </Transition>

        <v-form name="formConditions"
                class="shadow-box"
                style="border:1px solid #e0e0e0; padding:10px; width:60%">
            <TabView scrollable
                     style="overflow: visible;"
                     :pt="{ panelContainer: { class: 'form-tab-panel' } }">
                <TabPanel :header="__('Chart parameters')"
                          headerClass="form-tab-header">
                    <div class="grid">
                        <FormCalendar fieldName="from_date"
                                      label="From"
                                      size="2"
                                      validation="required"
                                      :isFocus="true"
                                      v-model:field="conditions.from_date" />

                        <FormCalendar fieldName="to_date"
                                      label="To"
                                      size="2"
                                      validation="required"
                                      v-model:field="conditions.to_date" />

                        <FormDropdown fieldName="worker_id"
                                      label="Worker"
                                      :showClear="true"
                                      size="3"
                                      validation="required"
                                      :filter="(event) => onFilter(event, 'myworkers')"
                                      :options="select?.myworkers"
                                      v-model:field="conditions.worker_id" />
                    </div>
                </TabPanel>
            </TabView>
            <div class="grid">
                <Button :label="__('Create')"
                        icon="pi pi-check"
                        class="p-button-success"
                        style="margin:10px 5px;"
                        @click="createChart"></Button>
                <Button :label="__('Cancel')"
                        icon="pi pi-times"
                        class="p-button-secondary"
                        style="margin:10px 5px;"
                        @click="cancelOperation">
                </Button>
            </div>
        </v-form>
    </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import FormDropdown from "@crud/FormDropdown.vue";
import FormCalendar from "@crud/FormCalendar.vue";
import Button from 'primevue/button';
import { router } from '@inertiajs/vue3';
import { __, makeChart } from '@pages/Helper/utils.js'
import { prepareSelect, onFilterService, validation } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------

const props = defineProps({
    chartParams: Object,
    conditions: { type: Object, default: {} }
})

const isLoading = ref(true);
const options = ["myworkers"];
const select = ref(null);

const conditions = ref(props.conditions)

// -----------------------------------------------------

onBeforeMount(async () => {
    isLoading.value = true;
    select.value = await prepareSelect(options, null, conditions)
    isLoading.value = false;
});

// -----------------------------------------------------

const createChart = () => {
    if (validation(conditions.value, 'formConditions')) {
        makeChart(props.chartParams, conditions, isLoading)
    }
}

// -----------------------------------------------------

const cancelOperation = () => {
    router.get(route('chart-index'));
}

// -----------------------------------------------------

const onFilter = async (event, option) => {
    await onFilterService(event, option, select, isLoading, conditions, null, options);
}

// -----------------------------------------------------
</script>

<style lang="scss"
       scoped></style>
